import axios from 'axios';

const aiApi = {};

aiApi.generateSimpleExercise = async (subject, options = {}) => {
    try {
        const response = await axios.post('/api/private/ai/generate-exercise', {
            subject,
            ...options,
        });
        return response.data;
    } catch (error) {
        console.error('Error generating simple exercise:', error);
        throw error;
    }
};

aiApi.generateExerciseWithSolution = async (subject, options = {}) => {
    try {
        const response = await axios.post('/api/private/ai/generate-exercise-with-solution', {
            subject,
            ...options,
        });
        return response.data;
    } catch (error) {
        console.error('Error generating exercise with solution:', error);
        throw error;
    }
};

aiApi.explainConcept = async (subject, concept, options = {}) => {
    try {
        const response = await axios.post('/api/private/ai/explain-concept', {
            subject,
            concept,
            ...options,
        });
        return response.data;
    } catch (error) {
        console.error('Error explaining concept:', error);
        throw error;
    }
};

export default aiApi;
